import store from '@/store';

export const valueFormatters = {
  methods: {
    canDoLedafValue: function(objective) {
      return objective.canDoLedaf ? store.state.translations.Yes : "-";
    },
    corrValue: function(objective) {
      return objective.corr ? objective.corr : "-";
    },
    coverGlassValue: function(objective) {
      let l;
      switch (objective.coverGlassFilter) {
        case 0:
          l = store.state.translations.WithoutCoverglass;
          break;
        case 1:
          l = store.state.translations.WithCoverglass;
          break;
        case 2:
          l = store.state.translations.WithAndWithoutCoverglass;
          break;
        case 3:
          l = "1.8 Quartz";
          break;

        default:
          break;
      }
      return l;
    },
    exitPupilPosValue: function(objective) {
      return objective.exitPupilPos ? objective.exitPupilPos : "-";
    },
    magnificationValue: function(objective) {
      return objective.magnification ? `${objective.magnification}x` : "-";
    },
    irisDiaphragmValue: function(objective) {
      return objective.irisDiaphragm === 0 ? store.state.translations.Without : objective.irisDiaphragm;
    },
    immersion: function(objective) {
      return store.state.translations[objective.immersion] || objective.immersion;
    },
    springLoaded: function(objective) {
      return objective.springLoaded ? store.state.translations.Yes : store.state.translations.No;
    },
    transmission: function(objective) {
      let t = "-";
      if (objective.tat5percentFilter == 9999) {
        t = store.state.translations.IR;
      } else if (objective.tat5percentFilter > 335 && objective.tat5percentFilter <= 360) {
        t = "UV (365nm)";
      } else if (objective.tat5percentFilter > 0 && objective.tat5percentFilter <= 335) {
        t = "UV (340nm)";
      }
      return t;
    },
    encodedContactURL: function(objective = null) {
      // Selected objective
      let so = objective ? objective.matnr : store.state.selectedObjective ? store.state.selectedObjective.matnr : "";

      // Compared objectives
      let co;
      if (store.state.objectivesToCompare) {
        let a = [];
        store.state.objectivesToCompare.forEach((obj) => {
          a.push(obj.matnr);
        });
        co = a.join(",");
      } else {
        co = "";
      }

      // Filter settings
      let fs = "";
      store.state.filterItems.forEach((fi) => {
        let ch = fi.filterOptions.filter((obj) => {
          return obj.checked;
        });

        if (ch.length) {
          let fss = "" + fi.filterItemTitle + ": ";

          for (let index = 0; index < ch.length; index++) {
            fss += ch[index].label + (index < ch.length - 1 ? ", " : "");
          }
          fs += fss + ";";
        }
      });

      return encodeURI(
        store.state.contactURL + "?inquiry_type_level2=quote_request_sales_contact&ofinder_selected_objective=" + so + "&ofinder_compared_objectives=" + co + "&ofinder_filter_settings=" + fs
      );
    },
  },
};
